import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import { isLoggedIn } from './IsLoggedIn';
import { Navigate } from 'react-router-dom';
import { getUserData } from '../utils/authUtils';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('../pages/dashboard/default')));
const NotFound = Loadable(lazy(() => import('../pages/component-overview/NotFoundPage')));

const Customer = Loadable(lazy(() => import('../pages/component-overview/Party/Customer/Customer')));
const Supplier = Loadable(lazy(() => import('../pages/component-overview/Party/Supplier/Supplier')));
const OtherExpense = Loadable(lazy(() => import('../pages/component-overview/Party/OtherExpense/OtherExpense')));
const Purchase = Loadable(lazy(() => import('../pages/component-overview/Purchase/Purchase')));
const PettyCash = Loadable(lazy(() => import('../pages/component-overview/PettyCash/PettyCash')));
const Invoice = Loadable(lazy(() => import('../pages/component-overview/Invoice/Invoice')));
const Assets = Loadable(lazy(() => import('../pages/component-overview/Assets/Assets')));
const Items = Loadable(lazy(() => import('../pages/component-overview/Items/Items')));
const SalesRpt = Loadable(lazy(() => import('../pages/component-overview/Reports/Sale/SaleRpt')));
const PurchaseRpt = Loadable(lazy(() => import('../pages/component-overview/Reports/Purchase/PurchaseRpt')));
const LedgerRpt = Loadable(lazy(() => import('../pages/component-overview/Reports/Ledger/LedgerRpt')));
const Users = Loadable(lazy(() => import('../pages/component-overview/Users/Users')));

const userData = getUserData();

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      path: '/',
      element: isLoggedIn() ? <DashboardDefault /> : <Navigate to="/login" />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: isLoggedIn() ? <DashboardDefault /> : <Navigate to="/login" />
        }
      ]
    },
    {
      path: 'customer',
      element: isLoggedIn() ? <Customer /> : <Navigate to="/login" />
    },
    {
      path: 'supplier',
      element: isLoggedIn() ? <Supplier /> : <Navigate to="/login" />
    },
    {
      path: 'other-expense',
      element: isLoggedIn() ? <OtherExpense /> : <Navigate to="/login" />
    },
    {
      path: 'purchase',
      element: isLoggedIn() ? <Purchase /> : <Navigate to="/login" />
    },
    {
      path: 'petty-cash',
      element: isLoggedIn() ? <PettyCash /> : <Navigate to="/login" />
    },
    {
      path: 'invoice',
      element: isLoggedIn() ? <Invoice /> : <Navigate to="/login" />
    },
    {
      path: 'assets',
      element: isLoggedIn() ? <Assets /> : <Navigate to="/login" />
    },
    {
      path: 'stocks',
      element: isLoggedIn() ? <Items /> : <Navigate to="/login" />
    },
    {
      path: 'sales-report',
      element: isLoggedIn() && userData.isAdmin ? <SalesRpt /> : <Navigate to={isLoggedIn() ? '/dashboard/default' : '/login'} />
    },
    {
      path: 'purchase-report',
      element: isLoggedIn() && userData.isAdmin ? <PurchaseRpt /> : <Navigate to={isLoggedIn() ? '/dashboard/default' : '/login'} />
    },
    {
      path: 'ledger-report',
      element: isLoggedIn() && userData.isAdmin ? <LedgerRpt /> : <Navigate to={isLoggedIn() ? '/dashboard/default' : '/login'} />
    },
    {
      path: 'users',
      element: isLoggedIn() && userData.isAdmin ? <Users /> : <Navigate to={isLoggedIn() ? '/dashboard/default' : '/login'} />
    },
    {
      path: '*',
      element: <NotFound />
    }
  ]
};

export default MainRoutes;
